module.exports = __webpack_public_path__ + "img/112_characters.7274bcc2.png";